import { useSyncExternalStore } from 'react';

import {
  BackendStatus,
  getBackendStatus,
  subscribeBackendStatus,
} from '../utils/backendStatus';

/**
 * Subscribes a component to the gateway API liveness state.
 *
 * @returns 'up' while the API answers, 'down' once an outage has been confirmed.
 */
const useBackendStatus = (): BackendStatus =>
  useSyncExternalStore(subscribeBackendStatus, getBackendStatus, getBackendStatus);

export default useBackendStatus;
